import { MessageBarType } from "@fluentui/react";
import { useState } from "react";
import { IDataResult, ResponseStatus, IResult } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { Authentication } from "../../common/views/Authentication";
import { DataUtils } from "../../common/views/DataUtils";
import { RouteUtils } from "../../common/views/RouteUtils";
import { Utils } from "../../common/views/Utils";
import { AccountModel, AccountProvider, AuthTokensInfo, LoginModel } from "../models/AccountTypes";
import { AccountService } from "../services/AccountService";

export type accountCallback = (account: AccountModel) => void;
export function useLoginVM() {
    const accountService = new AccountService();
    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const { form, setField, resetForm, errorMessages, setErrorMessages,
        summaryText, setSummaryText, summaryType, setSummaryType
    } = useForm<LoginModel>({
        countryCode: Authentication.getCountryCode() ?? "855",
        phoneNo: Authentication.getPhoneNo() ?? "",
        email: Authentication.getEmail(),
        telegram: false,
        provider: AccountProvider.phone,
        password: "",
        rememberMe: false
    });

    const submit = (callback: accountCallback) => {
        setLoading(true);

        if (form.provider === AccountProvider.phone) {
            form.email = undefined;
        }

        const request = accountService.login(form);
        DataUtils.onRequest(
            request,
            (result: IDataResult) => onResult(result, callback)
        );
    }

    const onResult = (result: IDataResult, callback: accountCallback) => {
        if (!result.errorMessages) result.errorMessages = {};
        var account = result.data as AuthTokensInfo;

        if (result.status === ResponseStatus.success && account) {
            onSuccess(account, callback);
        } else {
            onFail(result, callback);
        }

        setLoading(false);
    }

    const onSuccess = (account: AuthTokensInfo, callback: accountCallback) => {
        account.userRoles.keyHash = Utils.getRandomKey();
        RouteUtils.onLoggedIn(account);

        callback({
            userId: account.userId,
            isConfirmed: account.isConfirmed,
            options: []
        });

        resetForm();
    }

    const onFail = (result: IDataResult, callback: accountCallback) => {
        accountService.logout();
        RouteUtils.onLoggedOut();

        const res = result as IResult
        if (res) {
            setErrorMessages(res.errorMessages);
            setSummaryText(res.summaryText ?? "");
            setSummaryType(res.summaryType ?? MessageBarType.info);
        }

        var account = result.data as AuthTokensInfo;

        if (account && !Utils.isNullOrEmpty(account.userId) && !account.isConfirmed) {
            callback({
                userId: account.userId,
                isConfirmed: account.isConfirmed,
                options: []
            });

            resetForm();
        }
    }

    return {
        errorMessages,
        summaryText,
        summaryType,

        loading, setLoading,
        showConfirm, setShowConfirm,

        form,
        setField,
        submit
    }
}